import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuLinkElement,
  type TNavigationMenuLinkProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextControl } from "@/ui/components/typography/TextControl";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuLink = forwardRef<
  TNavigationMenuLinkElement,
  TNavigationMenuLinkProps
>(({ className, children, icon, ...props }, ref) => (
  <NavigationMenuPrimitive.Link
    ref={ref}
    data-component="NavigationMenuLink"
    className={cn(
      "group flex items-center gap-2 select-none rounded-sys-full p-2 font-sys-default text-sys-sm leading-none text-foreground no-underline outline-none transition-colors hover:bg-component-interactive-hover focus:bg-component-interactive-hover",
      className,
    )}
    {...props}
  >
    { icon ? (
      <Icon
        icon={icon}
        size="md"
        aria-hidden="true"
        className={cn(
          "group-hover:[&_svg]:fill-sys-chartreuse-600 group-hover:[&_svg]:stroke-foreground",
        )}
      />
    ) : null }
    <TextControl size={2} isResponsive={false}>
      { children }
    </TextControl>
  </NavigationMenuPrimitive.Link>
));

NavigationMenuLink.displayName = NavigationMenuPrimitive.Link.displayName;
